import { combineReducers } from "@reduxjs/toolkit";
import storeSlice from "./slices/storeSlice";
import filteredStoreSlice from "./slices/filteredStoresSlice";
import warehouseSlice from "./slices/warehouseSlice";
import employeeSlice from "./slices/employeeSlice";
import accountSubcategorySlice from "./slices/accountSubcategorySlice";
import incomeExpenseAccountSlice from "./slices/incomeExpenseAccountSlice";
import ledgerAccountSlice from "./slices/ledgerAccountSlice";
import paymentMethodXStoreSlice from "./slices/paymentMethodXStoreSlice";
import configurationXStoreSlice from "./slices/configurationXStoreSlice";
import msrXEmployeeSlice from "./slices/msrXEmployeeSlice";
import saleSlice from "./slices/saleSlice";
import fingerPrintXEmployeeSlice from "./slices/fingerPrintXEmployeeSlice";
import employeeTypeSlice from "./slices/employeeTypeSlice";
import companyTypeSlice from "./slices/companyTypeSlice";
import companySlice from "./slices/companySlice";
import saleStatusSlice from "./slices/saleStatusSlice";
import saleReturnReasonSlice from "../Maintenance/slices/returnReasonSlice";
import printReasonSlice from "../Maintenance/slices/printReasonSlice";
import transactionTypeSlice from "./slices/transactionTypeSlice";
import serviceCategoryslice from "./slices/serviceCategorySlice";
import entitySlice from "./slices/entitySlice";

export default combineReducers({
  store: storeSlice,
  filteredStore: filteredStoreSlice,
  warehouse: warehouseSlice,
  employee: employeeSlice,
  employeeType: employeeTypeSlice,
  accountSubcategory: accountSubcategorySlice,
  incomeExpenseAccount: incomeExpenseAccountSlice,
  ledgerAccount: ledgerAccountSlice,
  paymentMethodXStore: paymentMethodXStoreSlice,
  configurationXStore: configurationXStoreSlice,
  msrXEmployee: msrXEmployeeSlice,
  sale: saleSlice,
  saleStatus: saleStatusSlice,
  saleReturnReason: saleReturnReasonSlice,
  printReason: printReasonSlice,
  fingerPrintXEmployee: fingerPrintXEmployeeSlice,
  companyType: companyTypeSlice,
  company: companySlice,
  transactionTypes: transactionTypeSlice,
  serviceCategorys: serviceCategoryslice,
  entity: entitySlice
});
